import { Component, Input } from '@angular/core';
import { FullReservation } from '../../../core/models/reservation/full-reservation';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-desk-popover',
  imports: [TegelModule],
  templateUrl: './desk-popover.component.html',
  styleUrl: './desk-popover.component.scss'
})
export class DeskPopoverComponent {
  @Input() id!: string;
  @Input() profile?: FullReservation | null;
}
